import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class AgentDeliveryActiveCtrl implements IController {

  agentId: string;

  private loadLimit: any;
  private deliveriesRef: any;
  private infiniteScroll: any;
  private range: any;
  private customTemplates: any;
  private group: any;
  private status: any;
  private queryString: any;
  private selectedIds: any;
  private enabledStatuses: any;

  constructor(private $log, private $deliveries, private deliveriesConstants,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $infiniteScroll) {
  }

  $onInit() {
    this.loadLimit = 20;
    this.deliveriesRef = this.$deliveries();

    this.range = this.dateRangeTimeFiltersService.today();
    this.customTemplates = this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates();
    this.group = this.deliveriesConstants.group.Active;
    this.status = undefined;
    this.queryString = undefined;
    this.selectedIds = [];
    this.enabledStatuses = [
      this.deliveriesConstants.status.Assigned,
      this.deliveriesConstants.status.Started,
      this.deliveriesConstants.status.Aborted
    ];

    this.deliveriesRef.$query(this._qetQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.deliveriesRef, this.loadLimit);
  }

  submitQuery(queryString) {
    this.queryString = queryString;
    this._query();
  }

  rangeChanged(range) {
    if (!_.isUndefined(range) && !_.isEqual(range.name, this.range.name)) {
      this.range = range;
      this._query();
    }
  }

  statusChanged(status) {
    this.status = status;
    this._query();
  }

  selectedIdsChanged(selectedIds) {
    this.selectedIds = selectedIds;
  }

  private _query() {
    this.selectedIds = [];
    this.deliveriesRef.$query(this._qetQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((err) => {
        this.$log.debug('Fail to $query', err);
      })
  }

  private _qetQueryPayload() {
    return {
      agentIds: [this.agentId],
      from:   this.range.dateStart,
      to:     this.range.dateEnd,
      group:  this.group,
      status: this.status,
      query:  this.queryString,
      limit:  this.loadLimit
    };
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentDeliveryActive', {
    bindings: {
      agentId: '<'
    },
    template: require('./agent-delivery-active.html').default,
    controller: AgentDeliveryActiveCtrl
  });
